import{ init } from 'emailjs-com';

const SERVICE_ID = 'mustaquenadim';
const TEMPLATE_ID = 'mustaquenadim_template';
const USER_ID = init("user_2ndNs2fvzLORwxbB9H3D2");

export { SERVICE_ID, TEMPLATE_ID, USER_ID };